// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo-Logo-H0kAGm","LogoLarge":"Logo-LogoLarge-2K7NQJ"};